var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2441 5110 c-301 -64 -497 -262 -565 -572 l-6 -27 -448 -3 -447 -3 -80 -28 c-196 -68 -335 -217 -385 -412 -37 -145 -22 -292 44 -431 45 -96 161 -216 249 -258 l57 -28 0 -1407 c0 -955 3 -1426 11 -1467 16 -90 80 -214 148 -286 66 -70 138 -118 239 -157 l67 -26 1235 0 1235 0 67 26 c101 39 173 87 239 157 68 72 132 196 148 286 8 41 11 512 11 1467 l0 1407 58 28 c87 42 203 162 248 258 66 139 81 286 44 431 -50 195 -189 344 -385 412 l-80 28 -447 3 -448 3 -6 27 c-62 283 -228 470 -489 552 -79 25 -243 35 -314 20z m234 -285 c131 -39 231 -137 280 -276 l14 -39 -409 0 -409 0 14 39 c48 136 138 227 269 272 64 22 172 24 241 4z m1496 -626 c115 -54 172 -144 177 -281 4 -77 1 -93 -24 -148 -34 -75 -104 -141 -177 -167 -49 -17 -128 -18 -1587 -18 -1730 0 -1590 -6 -1686 78 -69 61 -104 140 -104 238 0 156 72 262 213 311 49 17 133 17 1592 15 l1540 -2 56 -26z m-191 -2279 l0 -1389 -21 -58 c-29 -76 -96 -143 -172 -172 l-58 -21 -1169 0 -1169 0 -58 21 c-76 29 -143 96 -172 172 l-21 58 0 1389 0 1390 1420 0 1420 0 0 -1390z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1753 2454 c-18 -9 -42 -31 -53 -49 -20 -32 -20 -45 -18 -865 l3 -832 37 -33 c49 -45 95 -53 150 -26 24 11 52 35 63 53 19 32 20 54 20 848 0 766 -1 817 -18 848 -36 65 -116 90 -184 56z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2489 2447 c-73 -48 -69 1 -69 -897 0 -747 1 -807 18 -839 26 -52 65 -76 122 -76 57 0 96 24 122 76 17 32 18 92 18 839 0 746 -1 808 -18 840 -23 46 -75 80 -122 80 -22 0 -51 -9 -71 -23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3233 2450 c-18 -10 -40 -34 -50 -52 -17 -31 -18 -82 -18 -848 0 -794 1 -816 20 -848 11 -18 39 -42 63 -53 55 -27 101 -19 150 26 l37 33 3 832 c2 821 2 833 -18 865 -38 62 -126 83 -187 45z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartAlt);
export default __webpack_public_path__ + "static/media/cart-alt.b06abcfc.svg";
export { ForwardRef as ReactComponent };